/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useFavorites, useFavoritesParams } from '../../../features/favorites';
import { fetchPartnerLessons, fetchPublicLessons
// @ts-expect-error Could not find a declaration file for module
} from '../../../actions/LessonActions';
import { fetchPartnerTracks, fetchPublicTracks
// @ts-expect-error Could not find a declaration file for module
} from '../../../actions/TrackActions';
import { useDispatch, useSelector } from 'react-redux';
import { getIsRequestingTracksOrLessons
// @ts-expect-error Could not find a declaration file for module
} from '../../../selectors/trackAndLessonSortingSelectors';
import { useCallback, useEffect, useState } from 'react';
import { useIsPartner } from '../../../features/partners';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
import UsageTracker from '../../../utils/UsageTracker';
import { SCREENS } from '../../../constants/Tracking';
import { SavedItemsPagedList } from '../../../features/savedItems';
import TrackCardContainer from '../../../containers/TracksPage/TrackCardContainer';
import LessonCardContainer from '../../../components/LessonCard/LessonCardContainer';
import { useLocation } from 'react-router-dom';
import { ShortCard } from '../../cards';
import getLang from 'LearningCenterUI/utils/getLang';
import ContentCardSkeleton from '../../../components/TrackCard/ContentCardSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
const FAVORITES_FILTERS = [FILTER_TYPES.AWARD_TYPE, FILTER_TYPES.CONTENT_TYPE, FILTER_TYPES.DURATION, FILTER_TYPES.SEARCH];
const useFetchSavedItemsRequirements = () => {
  const dispatch = useDispatch();
  const isPartner = useIsPartner();
  const fetchRequirements = useCallback(() => {
    dispatch(fetchPublicTracks());
    dispatch(fetchPublicLessons());
    if (isPartner) {
      dispatch(fetchPartnerTracks());
      dispatch(fetchPartnerLessons());
    }
  }, [dispatch, isPartner]);
  useEffect(() => {
    fetchRequirements();
  }, [fetchRequirements]);
  const tracksLessonsError = useSelector(state => state.tracks.get('recentError') || state.lessons.get('recentError'));
  const isRequestingTracksLessons = useSelector(state => getIsRequestingTracksOrLessons(state));
  return {
    tracksLessonsError,
    isRequestingTracksLessons
  };
};

// displays only initial watch later items on page load
const useInitialFavorites = () => {
  const location = useLocation();
  const {
    favoritedItems,
    favoritedItemsLoading
  } = useFavorites();
  const [favoriteItemsToDisplay, setFavoriteItemsToDisplay] = useState(null);

  // changing page or filters resets initial data load reference
  useEffect(() => {
    setFavoriteItemsToDisplay(null);
  }, [location]);
  useEffect(() => {
    if (!favoritedItemsLoading && !favoriteItemsToDisplay) {
      setFavoriteItemsToDisplay(favoritedItems);
    }
  }, [favoriteItemsToDisplay, favoritedItems, favoritedItemsLoading]);
  return favoriteItemsToDisplay;
};
export const FavoritesList = () => {
  const {
    tracksLessonsError,
    isRequestingTracksLessons
  } = useFetchSavedItemsRequirements();
  const {
    hasFavorites,
    favoritedItems,
    favoritedItemsLoading,
    favoritedItemsError
  } = useFavorites();
  const favoriteItemsToDisplay = useInitialFavorites();
  const {
    page
  } = useFavoritesParams();
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: SCREENS.FAVORITES
    });
  }, []);
  const isGhost = useCallback((id, type) => {
    return favoritedItems !== null && !favoritedItems.some(p => p.contentId === id && p.contentType === type);
  }, [favoritedItems]);
  const error = favoritedItemsError || tracksLessonsError;
  const isRequesting = isRequestingTracksLessons || favoritedItemsLoading;
  return /*#__PURE__*/_jsx(SavedItemsPagedList, {
    error: error,
    filters: FAVORITES_FILTERS,
    hasError: !!error,
    hasItems: hasFavorites,
    isRequesting: isRequesting,
    itemKey: "favorites",
    list: favoriteItemsToDisplay && favoriteItemsToDisplay.map(({
      contentId,
      contentType
    }, index) => {
      return contentType === 'SHORT_FORM_CONTENT' ?
      /*#__PURE__*/
      // language is not currently saved but required for shorts: ACALEARN-665
      _jsx(ShortCard, {
        appearsIn: "favourites-results",
        isGhost: isGhost(contentId, 'SHORT_FORM_CONTENT'),
        language: getLang(),
        loadingState: /*#__PURE__*/_jsx(ContentCardSkeleton, {}),
        position: index + 1,
        shortId: contentId
      }, `short-${contentId}`) : contentType === 'TRACK' ? /*#__PURE__*/_jsx(TrackCardContainer, {
        appearsIn: "favourites-results",
        isGhost: isGhost(contentId, 'TRACK'),
        position: index + 1,
        trackId: contentId
      }, `track-${contentId}`) : /*#__PURE__*/_jsx(LessonCardContainer, {
        appearsIn: "favourites-results",
        isGhost: isGhost(contentId, 'LESSON'),
        lessonId: contentId,
        position: index + 1
      }, `lesson-${contentId}`);
    }),
    markerKey: "FAVORITES",
    page: page,
    totalCount: favoriteItemsToDisplay ? favoriteItemsToDisplay.length : 0
  });
};
export default FavoritesList;